import * as React from "react"
import {
  RadioButtonFieldBlock,
  RadioButtonFieldBlockProps,
} from "gatsby-interface"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"
import { NotificationEventType } from "@modules/graphql/types"
import { notificationEventTypeLabels } from "./constants"

const eventOptions: RadioButtonFieldBlockProps["options"] = [
  NotificationEventType.BuildSucceeded,
  NotificationEventType.BuildFailed,
  NotificationEventType.DeploySucceeded,
  NotificationEventType.DeployFailed,
].map(value => ({
  value,
  label: notificationEventTypeLabels[value],
}))

export type NotificationEventFieldProps = Omit<
  RadioButtonFieldBlockProps,
  "label" | "options"
>

export function NotificationEventField(props: NotificationEventFieldProps) {
  return (
    <RadioButtonFieldBlock
      label={notificationDeploysText.labels.eventToListen}
      options={eventOptions}
      {...props}
    />
  )
}
